<template src="./ForgotPassword.html"/>
<style lang="scss" scoped src="./ForgotPassword.scss"/>


<script>

import {SfAlert, SfButton, SfInput, SfLoader, SfHeading} from '@storefront-ui/vue';
import Api from "@/api/Api";
import OrkRecaptcha from "@/components/Ork/OrkRecaptcha";

export default {
  name: "ForgotPassword",
  components: {
    OrkRecaptcha,
    SfAlert,
    SfInput,
    SfButton,
    SfLoader,
    SfHeading
  },
  data() {
    return {
      loading: false,
      error: null,
      valid: false,
      submitted: false,
      email: "",
      emailBlur: true
    }
  },
  watch: {
    isLogIn() {
      this.email = ""

    },
  },
  methods: {
    executeRecaptcha() {
      this.$refs.recaptchaResetPasswordForm.execute()
    },
    validate() {

      this.emailBlur = false;

      if (
          this.validEmail(this.email)
      ) {
        this.valid = true;
      }
    },
    validEmail(email) {
      const regex = /(.+)@(.+){2,}\.(.+){2,}/
      const hasWhiteSpace = /\s/;
      if (regex.test(email.toLowerCase()) && !hasWhiteSpace.test(email.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },
    submitForgotForm(token) {
      const onComplete = () => {
        if (!this.error || this.error.status === 200) {
          this.loading = false;
        } else {
          this.loading = false;
        }
      };

      const onError = (e) => {
        this.error = e;
        this.loading = false;
      };
      this.validate()
      if (this.valid) {
        this.loading = true;
        this.$emit('submit', {
          form: {email: this.email, recaptchaData: token},
          onComplete,
          onError
        });
      }
    }
  }
}
</script>

